(function () {
  'use strict';

  function bar() { return document.getElementById('jmt-prefbar'); }
  function clean(value) { return String(value || '').replace(/\s+/g, ' ').trim(); }
  function shortSize(value) { return clean(value).split(/\s+/)[0] || ''; }

  function summary(pref) {
    if (!pref) return '';
    var pouch = clean(pref.pouchStyle || pref.cut);
    var size = shortSize(pref.waistSize || pref.size);
    var back = clean(pref.thongStrapStyle);
    var backLabel = back.replace(/\s+Back$/i, '');
    return pouch && size && backLabel ? [pouch, size, backLabel].join(' · ') : '';
  }

  function render(pref) {
    var root = bar();
    if (!root) return;
    var completeSummary = summary(pref);
    var summaryNode = root.querySelector('[data-jmt-pref-summary]');
    root.dataset.jmtPrefComplete = completeSummary ? 'true' : 'false';
    if (summaryNode) summaryNode.textContent = completeSummary || 'Choose a pouch, waist size, and back style';
  }

  function refreshCount(cart) {
    var root = bar();
    var node = root && root.querySelector('#jmt-prefbar-cart-count');
    if (!node) return;
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    node.textContent = String(count);
    node.hidden = count < 1;
  }

  var countRevision = 0;
  function fetchCount() {
    var revision = ++countRevision;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (revision === countRevision) refreshCount(cart);
      })
      .catch(function () {});
  }

  function start() {
    if (!bar()) return;
    var api = window.JMT_PREF;
    render(api && api.get ? api.get() : null);
    fetchCount();
    window.addEventListener(api && api.EVT ? api.EVT : 'jmt:pref:change', function (event) {
      render(event.detail || (api && api.get ? api.get() : null));
    });
    window.addEventListener('jmt:cart:refresh', fetchCount);
    window.addEventListener('jmt:cart:changed', fetchCount);
    // Drawer quantity changes/removals publish the theme's cart update event.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData && typeof event.cartData.item_count === 'number') {
          ++countRevision;
          refreshCount(event.cartData);
        } else {
          fetchCount();
        }
      });
    }
    window.addEventListener('pageshow', function () {
      render(api && api.get ? api.get() : null);
      fetchCount();
    });
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
